import { Injectable, Provider, SkipSelf, Optional } from '@angular/core';
import { MdDialog, MdDialogRef, MdDialogConfig, ComponentType } from '@angular/material';

import { PuiAlertConfig, PuiConfirmConfig, PuiPromptConfig, PuiDialogConfig, PuiDialogRef } from './dialog-config';
import { PuiConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { PuiAlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { PuiPromptDialogComponent } from './prompt-dialog/prompt-dialog.component';

@Injectable()
export class PuiDialogService {

    constructor(private dialogService: MdDialog) { }

    closeAll() {
        this.dialogService.closeAll();
    }

    public openAlert(config: PuiAlertConfig): PuiDialogRef<PuiAlertDialogComponent> {
        let dialogConfig: MdDialogConfig = this.createConfig(config);
        let dialogRef: MdDialogRef<PuiAlertDialogComponent> =
            this.dialogService.open(PuiAlertDialogComponent, dialogConfig);
        let alertDialogComponent: PuiAlertDialogComponent = dialogRef.componentInstance;

        alertDialogComponent.title = config.title;
        alertDialogComponent.message = config.message;

        if (config.closeButton) {
            alertDialogComponent.closeButton = config.closeButton;
        }

        return new PuiDialogRef(dialogRef);
    }

    openConfirm(config: PuiConfirmConfig): PuiDialogRef<PuiConfirmDialogComponent> {
        let dialogConfig: MdDialogConfig = this.createConfig(config);
        let dialogRef: MdDialogRef<PuiConfirmDialogComponent> =
            this.dialogService.open(PuiConfirmDialogComponent, dialogConfig);
        let confirmDialogComponent: PuiConfirmDialogComponent = dialogRef.componentInstance;

        confirmDialogComponent.title = config.title;
        confirmDialogComponent.message = config.message;

        if (config.acceptButton) {
            confirmDialogComponent.acceptButton = config.acceptButton;
        }
        if (config.cancelButton) {
            confirmDialogComponent.cancelButton = config.cancelButton;
        }

        return new PuiDialogRef(dialogRef);
    }

    openPrompt(config: PuiPromptConfig): PuiDialogRef<PuiPromptDialogComponent> {
        let dialogConfig: MdDialogConfig = this.createConfig(config);
        let dialogRef: MdDialogRef<PuiPromptDialogComponent> =
            this.dialogService.open(PuiPromptDialogComponent, dialogConfig);
        let promptDialogComponent: PuiPromptDialogComponent = dialogRef.componentInstance;

        promptDialogComponent.title = config.title;
        promptDialogComponent.message = config.message;
        promptDialogComponent.value = config.value;

        if (config.acceptButton) {
            promptDialogComponent.acceptButton = config.acceptButton;
        }
        if (config.cancelButton) {
            promptDialogComponent.cancelButton = config.cancelButton;
        }

        return new PuiDialogRef(dialogRef);
    }

    open<T>(component: ComponentType<T>, config?: PuiDialogConfig): PuiDialogRef<T> {
      return new PuiDialogRef(this.dialogService.open(component, this.createConfig(config || <PuiDialogConfig>{})));
    }

    private createConfig(config: PuiDialogConfig): MdDialogConfig {
        let dialogConfig: MdDialogConfig = new MdDialogConfig();
        dialogConfig.viewContainerRef = config.viewContainerRef;
        dialogConfig.disableClose = config.disableClose;
        dialogConfig.height = config.height;
        dialogConfig.width = config.width;
        return dialogConfig;
    }
}

export function DIALOG_PROVIDER_FACTORY(
    parent: PuiDialogService, dialog: MdDialog): PuiDialogService {
    return parent || new PuiDialogService(dialog);
}

export const DIALOG_PROVIDER: Provider = {
    // provide new one if not exist
    provide: PuiDialogService,
    deps: [[new Optional(), new SkipSelf(), PuiDialogService], MdDialog],
    useFactory: DIALOG_PROVIDER_FACTORY,
};
